import { render, staticRenderFns } from "./IsolationMaterials.vue?vue&type=template&id=16f0c081"
import script from "./IsolationMaterials.vue?vue&type=script&lang=js"
export * from "./IsolationMaterials.vue?vue&type=script&lang=js"
import style0 from "./IsolationMaterials.vue?vue&type=style&index=0&id=16f0c081&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports